import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8b34678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-content-end mb-4" }
const _hoisted_2 = { class: "d-lg-flex" }
const _hoisted_3 = { class: "me-lg-4" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "table-responsive mb-4 text-break" }
const _hoisted_6 = { class: "table table-borderless w-max-content" }
const _hoisted_7 = { class: "align-middle text-center" }
const _hoisted_8 = { class: "rounded-top" }
const _hoisted_9 = { class: "rounded-top" }
const _hoisted_10 = ["checked", "onChange"]
const _hoisted_11 = { class: "d-flex text-decoration-underline max-w-content text-start" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_14 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_15 = {
  key: 0,
  class: "me-2"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "unread-count"
}
const _hoisted_20 = ["src", "onClick"]
const _hoisted_21 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_22 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = { class: "me-lg-4" }
const _hoisted_25 = { class: "d-flex align-items-center" }

import { ref, watchEffect, computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Loading from '@/components/loading/index.vue'
import Button from '@/components/button/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Pagination from '@/components/pagination/index.vue'
import CellSort from '@/components/sort-field-table/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import ModalAddToGroup from '@/views/community-admin/user-management/shared-components/ModalAddToGroup.vue'
import ModalConfirmAddToGroup from '@/views/community-admin/user-management/shared-components/ModalConfirmAddToGroup.vue'
import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import ModalConfirmDelete from './components/ModalConfirmDelete.vue'
import ModalConfirmCsv from './components/ModalConfirmCsv.vue'
import ModalSuccess from './components/ModalSuccess.vue'
import TotalRecords from '@/components/total-records/index.vue'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import _ from 'lodash'
import { formatUnreadCount } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  dataQuery: Object,
  isFilter: Boolean,
},
  setup(__props) {

const props = __props

const router = useRouter()
const route = useRoute()
const store = useStore()
const dataAlmunus = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_COMMUNITY_ALUMNUS]?.listCommunityAlumnus)
const totalPages = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_COMMUNITY_ALUMNUS]?.total_pages)
const totalRecords = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_COMMUNITY_ALUMNUS]?.total_records)
const listManagementNo = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.LIST_MANAGEMENT_NO].alumni)
const allRecords = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_ALL_DATA]?.alumni)

const getCommunityAlumnus = (params: any) => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_COMMUNITY_ALUMNUS, {
    id: router.currentRoute.value.params?.id,
    params,
    data: props.dataQuery,
  })
}



const data = ref()
const isCheckedAll = ref<boolean>(false)
const listUserFailed = ref<any[]>([])

onMounted(async () => {
  if (allRecords.value?.length > 0 && listManagementNo.value.length == allRecords.value.length) {
    isCheckedAll.value = true
  } else {
    isCheckedAll.value = totalRecords.value > 0 && listManagementNo.value?.length === totalRecords.value
  }
})

watchEffect(() => {
  data.value = dataAlmunus.value?.map((item: any) => {
    return { ...item }
  })
})

const modalGroupData = ref<any>({})
const setModalGroupData = (data: { id: string; name: string }) => {
  modalGroupData.value = data
}

const transitMessageCommon = () => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, listManagementNo.value)

  router.push(`/community/communities/${route?.params?.id}/alumnus/send_messages?user_type=2`)
  //transit to OE50
}

const transitYelloopPoint = () => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, listManagementNo.value)
  router.push(`/community/communities/${route?.params?.id}/alumnus/granted_points`)
  //transit to OE56
}
const transitUserManagementFlag = () => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_ALUMNAI_SELECTED, listManagementNo.value)
  router.push(`/community/communities/${route.params?.id}/alumnus/alumnus-management-flag-update`)
  //transit to OE53
}

const transitOnlyManagementFlag = (item: any) => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, [item])
  router.push(`/community/communities/${route.params?.id}/alumnus/send_messages?user_type=2`)
}

const handleTransitDetail = (userId: any): void => {
  router.push(`/community/communities/${route.params?.id}/alumnus/${userId}/edit`)
}

const handleCheckID = (id: string) => {
  const dataCheck = data.value.filter((record) => record.management_no === id)
  const payload = {
    typeData: 'alumni',
    data: dataCheck[0],
  }
  if (dataCheck.length > 0) store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_LIST_MANAGEMENT_NO, payload)

  if (allRecords.value?.length > 0 && listManagementNo.value.length === allRecords.value.length) {
    isCheckedAll.value = true
  } else {
    isCheckedAll.value = listManagementNo.value?.length === totalRecords.value
  }
}

const loadingCheckAll = ref<boolean>(false)

const handleCheckAll = async (): void => {
  if (isCheckedAll.value) {
    loadingCheckAll.value = true
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_ALL_DATA, {
      id: route.params?.id,
      data: {
        ...props.dataQuery,
        group_id: route.query?.group_id ?? props.dataQuery.group_id,
      },
      typeData: 'alumni',
    })
    await getCommunityAlumnus({ ...router.currentRoute.value.query, page_of_number: router.currentRoute.value.query?.page_of_number || 30 })
    const payload = {
      typeData: 'alumni',
      type: 'checkAll',
      data: allRecords.value,
    }
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, payload)
    loadingCheckAll.value = false
  } else {
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'alumni', type: 'unCheckAll', data: [] })
  }
}

const transitDirectChat = (chatroom_id: string) => {
  router.push(`/community/communities/${route.params?.id}/admin/direct_chat/${chatroom_id}`)
}

const getListUserFailed = (list: any[]): void => {
  listUserFailed.value = list
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

watch(
  [
    () => route.query?.page,
    () => route.query?.page_of_number,
    () => route.query?.management_no,
    () => route.query?.customer_name,
    () => route.query?.last_login,
    () => route.query?.record_status,
    () => route.query?.department_name,
    () => route.query?.institution,
    () => route.query?.job_type,
  ],
  () => {
    if (dataAlmunus.value?.length && route.path.match('/alumnus')) {
      getCommunityAlumnus({ ...router.currentRoute.value.query, page_of_number: router.currentRoute.value.query?.page_of_number || 30 })
    }
  }
)

watch(
  () => route.path,
  () => {
    store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'alumni', type: 'unCheckAll', data: [] })
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Button, {
          title: "CSVダウンロード",
          type: "secondary",
          disabled: _unref(listManagementNo).length === 0,
          dataBsToggle: "modal",
          "class-name": "me-lg-4 mb-4",
          dataBsTarget: "#modalConfirmCsvAlmunus"
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          title: _unref(translate)('OE12addToGroup'),
          type: "secondary",
          "class-name": "me-lg-4 mb-4",
          dataBsToggle: "modal",
          dataBsTarget: "#modalAddUserToGroup",
          disabled: _unref(listManagementNo).length === 0
        }, null, 8, ["title", "disabled"]),
        _createVNode(Button, {
          title: 'メッセージ一括送信',
          type: 'secondary',
          disabled: _unref(listManagementNo).length === 0,
          "class-name": "me-lg-4 mb-4",
          onClick: transitMessageCommon
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          title: 'YELLポイント一括付与',
          type: 'secondary',
          disabled: _unref(listManagementNo).length === 0,
          "class-name": "me-lg-4 mb-4",
          onClick: transitYelloopPoint
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          title: 'ユーザ管理フラグ一括更新',
          type: 'secondary',
          disabled: _unref(listManagementNo).length === 0,
          "class-name": "me-lg-4 mb-4",
          onClick: transitUserManagementFlag
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          title: '一括脱退',
          type: 'secondary',
          "class-name": "mb-4",
          disabled: _unref(listManagementNo).length === 0,
          dataBsToggle: 'modal',
          dataBsTarget: '#modalConfirmDeleteAlmunus'
        }, null, 8, ["disabled"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(TotalRecords, {
          totalRecords: _unref(totalRecords),
          totalChecked: _unref(listManagementNo).length,
          isChecked: true
        }, null, 8, ["totalRecords", "totalChecked"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Pagination, {
              totalDataOfPage: _unref(dataAlmunus)?.length,
              totalPage: _unref(totalPages),
              changDelete: true
            }, null, 8, ["totalDataOfPage", "totalPage"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_7, [
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input cursor-pointer",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCheckedAll).value = $event)),
                      value: "",
                      id: "flexCheckDefault",
                      onChange: handleCheckAll
                    }, null, 544), [
                      [_vModelCheckbox, isCheckedAll.value]
                    ])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_unref(translate)('OE10selectAll')), 1)
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('managementNo'),
                    keyName: 'management_no'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('fullName'),
                    keyName: 'customer_name'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('affiliation'),
                    keyName: 'institution'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('occupation'),
                    keyName: 'job_type'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('lastLoginDate'),
                    keyName: 'last_login'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, _toDisplayString(_unref(translate)('OE10userDirect2')), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(translate)('message')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["align-middle text-center", {
                rowEven: index % 2 === 0,
                rowAvailable: item.status === 'leave',
                rowDeleted: item.status === 'available',
                rowChecked: _unref(_).map(_unref(listManagementNo), 'management_no').includes(item.management_no),
              }]),
                  key: index
                }, [
                  _createElementVNode("td", null, [
                    (item?.status !== 'leave')
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "form-check-input cursor-pointer",
                          type: "checkbox",
                          id: "flexCheckDefault",
                          checked: _unref(_).map(_unref(listManagementNo), 'management_no').includes(item.management_no),
                          onChange: ($event: any) => (handleCheckID(item.management_no))
                        }, null, 40, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.management_no), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(UserAliasIcon, { userType: '2' }),
                      _createElementVNode("div", {
                        onClick: () => handleTransitDetail(item.management_no),
                        class: "cursor-pointer"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.family_name + ' ' + item.given_name), 1),
                        (item?.status === 'leave')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(translate)('SO10user30')), 1))
                          : _createCommentVNode("", true),
                        (item?.status === 'available')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(translate)('OE12pause')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, "（" + _toDisplayString(item.display_name) + "）", 1)
                      ], 8, _hoisted_12)
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.institution || '-'), 1),
                  _createElementVNode("td", null, [
                    (item?.job_type_parent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item?.job_type_parent), 1))
                      : _createCommentVNode("", true),
                    (item?.job_type_child)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.job_type_child), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.last_login ? _unref(ConvertFromLocalTime)(item.last_login) : '-'), 1),
                  _createElementVNode("td", null, [
                    (item.status === 'examinated')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "wrapper-user",
                          onClick: ($event: any) => (transitDirectChat(item.chatroom_id))
                        }, [
                          _createElementVNode("img", {
                            src: require('@/assets/images/user-active.svg')
                          }, null, 8, _hoisted_18),
                          (item?.count_unread)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(formatUnreadCount)(item?.count_unread)), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (item.status === 'examinated')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "cursor-pointer",
                          src: require('@/assets/images/mail-active.svg'),
                          onClick: () => transitOnlyManagementFlag(item)
                        }, null, 8, _hoisted_20))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          (__props.isFilter && !_unref(dataAlmunus)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('CC40noData')), 1))
            : _createCommentVNode("", true),
          (!__props.isFilter && !_unref(dataAlmunus)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('CC10noData')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(Pagination, {
              totalDataOfPage: _unref(dataAlmunus)?.length,
              totalPage: _unref(totalPages),
              changDelete: true
            }, null, 8, ["totalDataOfPage", "totalPage"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ])
        ])
      ])
    ]),
    _createVNode(ModalAddToGroup, {
      data: _unref(listManagementNo),
      setGroupData: setModalGroupData,
      groupDataId: modalGroupData.value.id,
      showDisplayName: true
    }, null, 8, ["data", "groupDataId"]),
    _createVNode(ModalConfirmAddToGroup, {
      data: _unref(listManagementNo),
      groupData: modalGroupData.value,
      setGroupData: setModalGroupData,
      showDisplayName: true
    }, null, 8, ["data", "groupData"]),
    _createVNode(ModalConfirmDelete, {
      data: _unref(listManagementNo),
      getListUserFailed: getListUserFailed,
      reload: () => getCommunityAlumnus({ ..._unref(router).currentRoute.value.query, page_of_number: _unref(router).currentRoute.value.query?.page_of_number || 30 })
    }, null, 8, ["data", "reload"]),
    _createVNode(ModalConfirmCsv, {
      data: _unref(listManagementNo),
      getListUserFailed: getListUserFailed,
      reload: () => getCommunityAlumnus({ ..._unref(router).currentRoute.value.query, page_of_number: _unref(router).currentRoute.value.query?.page_of_number || 30 })
    }, null, 8, ["data", "reload"]),
    _createVNode(ModalSuccess, {
      data: data.value,
      listUserFailed: listUserFailed.value
    }, null, 8, ["data", "listUserFailed"]),
    _createVNode(Loading, { loading: loadingCheckAll.value }, null, 8, ["loading"])
  ], 64))
}
}

})